import { Injectable } from '@angular/core';
import { Router, NavigationEnd, ActivatedRoute } from '@angular/router';
import { Title } from '@angular/platform-browser';
import { map, filter } from 'rxjs/operators';
import { HttpClient } from '@angular/common/http';
import { AppConfig } from '../../../app/global';

@Injectable({
  providedIn: 'root'
})
export class ZoCommonService {

  constructor(private router: Router,
              private activatedRoute: ActivatedRoute,
              private titleService: Title,
              private httpClient: HttpClient) {

  }

  public setTitle() {
    this.router.events
      .pipe(
        filter(event => event instanceof NavigationEnd),
        map(() => this.router)
      )
      .subscribe((event) => {
        // const titles = this.getTitle(this.router.routerState, this.router.routerState.root);
        // const title = titles[titles.length - 1];
        
        this.httpClient.get(AppConfig.GET_MERCHANT).subscribe((data: any) => {
          this.titleService.setTitle(data.data.name);
        });


        // if (title) {
        //   this.titleService.setTitle(title);
        // }
      });
  }

  public getTitle(state, parent) {
    const data = [];
    if (parent && parent.snapshot.data && parent.snapshot.data.title) {
      data.push(parent.snapshot.data.title);
    }
    if (state && parent) {
      data.push(...this.getTitle(state, state.firstChild(parent)));
    }
    return data;
  }

}
